import React from "react";
import { Image_Url} from "../../constants/imageUrl/ImageUrl"
import "./header.css";

function Login() {
  return (
    <div className="HeaderConatiner">
      <div className="headerContainers">
        <div className="headeradmin">
          <img className="Header_Image" src={Image_Url.TVSADMIN1} />
    
        {/* <div className="Change_Passwords">
        <select>
          <option value="Change Password">Change Password</option>
          <option value="logout">Logout</option>
        </select>
      </div> */}
      </div>
      </div>
    </div>
  );
}
export default Login;
